import {
  buildDefaultSortStack,
  isDefaultSortStack,
  SortCriterion,
} from './columnSortUtils'

export type SortColumnDef<Field extends string = string> = {
  value: Field
  label: string
}

export type ShareLinkSortField =
  | 'productName'
  | 'shortUrl'
  | 'createdAt'
  | 'clicksCount'
  | 'earnings'

export type TransactionSortField =
  | 'createDate'
  | 'brandName'
  | 'cashBack'
  | 'transactionAmount'
  | 'status'
  | 'source'

export const SHARE_LINK_TABLE_SORT_COLUMNS: SortColumnDef<
  ShareLinkSortField
>[] = [
  { value: 'productName', label: 'item' },
  { value: 'shortUrl', label: 'link' },
  { value: 'createdAt', label: 'created' },
  { value: 'clicksCount', label: 'total clicks' },
  { value: 'earnings', label: 'total earned' },
]

export const TRANSACTION_TABLE_SORT_COLUMNS: SortColumnDef<
  TransactionSortField
>[] = [
  { value: 'createDate', label: 'date' },
  { value: 'brandName', label: 'retailer' },
  { value: 'transactionAmount', label: 'transaction amount' },
  { value: 'cashBack', label: 'your cash back' },
  { value: 'status', label: 'status' },
  { value: 'source', label: 'source' },
]

export const DEFAULT_SHARE_LINK_SORT_STACK: SortCriterion<
  ShareLinkSortField
>[] = []
export const DEFAULT_TRANSACTION_SORT_STACK: SortCriterion<
  TransactionSortField
>[] = []

export const SHARE_LINK_SORT_DEFAULT_LABEL = 'sort columns'
export const TRANSACTION_SORT_DEFAULT_LABEL = 'sort columns'

export function shareLinkSortStackForApi(
  sortStack: SortCriterion<ShareLinkSortField>[]
): SortCriterion<ShareLinkSortField>[] {
  return sortStack
}

export function transactionSortStackForApi(
  sortStack: SortCriterion<TransactionSortField>[]
): SortCriterion<TransactionSortField>[] {
  return sortStack
}

export function isDefaultShareLinkColumnSorts(
  sortStack: SortCriterion<ShareLinkSortField>[]
): boolean {
  return isDefaultSortStack(sortStack, DEFAULT_SHARE_LINK_SORT_STACK)
}

export function isDefaultTransactionColumnSorts(
  sortStack: SortCriterion<TransactionSortField>[]
): boolean {
  return isDefaultSortStack(sortStack, DEFAULT_TRANSACTION_SORT_STACK)
}
